import { registerMicroApps, runAfterFirstMounted, setDefaultMountApp, start } from "qiankun"
import createDynamicLink from '@/utils/dynamicLink'
/**
 * @name 声明子应用挂载dom，如果不需要做keep-alive，则只需要一个dom即可；
 */
const appContainer = "#subapp-viewport"
import store from '@/store'

/**
 * 路由监听
 * @param {*} routerPrefix 前缀
 */
function genActiveRule(routerPrefix) {
  return location => location.pathname.startsWith(routerPrefix);
}

const qianKunStart = (list = []) => {
  /**
   * @name 处理子应用注册表数据
   */
  let apps = []  // 子应用数组盒子
  let defaultApp = null  // 默认注册应用路由前缀
  const env = process.env.VUE_APP_MODE
  list.forEach((i) => {
    if (i.name && i.entry) {
      const configInfo = {
        name: i.name,
        container: appContainer,
        activeRule: i.routerBase,
        entry: env === 'local' ? i.entryDev : i.entry
      }
      apps.push(configInfo)
    }
    if (i.defaultRegister) defaultApp = i.routerBase
  })
  /**
  * @name 注册子应用
  * @param {Array} list subApps
  */
  registerMicroApps(
    apps,
    {
      beforeLoad: [
        app => {
          const { entry } = app
          createDynamicLink(entry)
          if (app.name === 'financialManagement') {
            store.commit('CHANGE_SUBAPP_NAME', true)
          } else {
            store.commit('CHANGE_SUBAPP_NAME', false)
          }
        },
      ],
      beforeMount: [
        app => {
        },
      ],
      beforeUnmount: [
        app => {
          let less = document.querySelector('link[rel="stylesheet/less"]')
          if (less) {
            less.parentNode && less.parentNode.removeChild && less.parentNode.removeChild(less)
          }
        }
      ],
      afterUnmount: [
        app => {
          console.log('[LifeCycle] after unmount %c%s', 'color: green;', app.name)
        },
      ],
    },
  )
  /**
   * @name 设置默认进入的子应用
   * @param {String} 需要进入的子应用路由前缀
   */
  setDefaultMountApp(defaultApp)

  /**
   * @name 启动微前端
   */
  start({
    prefetch: false,
    // ||  url.indexOf('api.map.baidu.com') !== -1 
    // excludeAssetFilter: url => url.indexOf('color.less') !== -1 || url.indexOf('less.min.js') !== -1 || url.indexOf('jsencrypt.min.js') !== -1 || url.indexOf('jsWebControl-1.0.0.min.js') !== -1  || url.indexOf('bcebos.com')!=-1 || url.indexOf('bdimg.com')!=-1
    strictStyleIsolation: true,
    excludeAssetFilter: (assetUrl) => {
      const whiteList = [];
      const whiteWords = ['baidu', 'map', 'api.map.baidu.com', 'color.less', 'less.min.js', 'jsencrypt.min.js', 'jsWebControl-1.0.0.min.js', 'bcebos.com', 'bdimg.com'];
      if (whiteList.includes(assetUrl)) { return true }
      return whiteWords.some(w => { return assetUrl.includes(w) })
    }

  })

  /**
   * @name 微前端启动进入第一个子应用后回调函数
   */
  runAfterFirstMounted(() => { })

  /**
 * @name 启动qiankun应用间通信机制
 */
  // appStore(initGlobalState)
}

export default qianKunStart
